// src\components\Dropdown\Dropdown.jsx
import React from 'react';
import PropTypes from 'prop-types';
import './Dropdown.css'; // Assuming Dropdown.css is in the same folder

const Dropdown = ({
  label,
  options,
  value,
  onChange,
}) => (
  <div className="dropdown-container">
    <label className="dropdown-label" htmlFor="dropdown-select">
      {label}
    </label>
    <select
      className="dropdown-select"
      value={value}
      id="dropdown-select"
      onChange={(e) => onChange(e.target.value)}
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);

Dropdown.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Dropdown;
